<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="" elevation="" max-width="">
          <v-card-title class="justify-center"> NUEVO BLOG </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p>
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'inicioPanel' }"
                    >Inicio</router-link
                  >
                  /
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'blogsPanel' }"
                    >Blogs</router-link
                  >
                  /
                  <router-link
                    exact=""
                    style="text-decoration: none"
                    :to="{ name: 'blogsCrearPanel' }"
                    >Crear</router-link
                  >
                </p>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-form @submit.prevent="guardar()" :disabled="processForm">
              <v-row>
                <v-col cols="12">
                  <v-alert
                    type="error"
                    v-model="alertError"
                    dismissible
                    ref="mensajeError"
                  >
                    <ul v-for="(errors, index) in listErrors" :key="index">
                      <li v-text="errors[0]"></li>
                    </ul>
                  </v-alert>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    dense
                    label="Titulo blog (*)"
                    v-model="blog.titulo"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    rows="3"
                    dense
                    clearable
                    clear-icon="mdi-close-circle"
                    label="Descripción"
                    v-model="blog.descripcion"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <p class="my-0">Contenido</p>
                  <ckeditor
                    :editor-url="apiUrl('js/ckeditor/ckeditor.js')"
                    v-model="blog.contenido"
                    :config="{
                      filebrowserBrowseUrl: '/plugin_externos/ckfinder/ckfinder.html',
                      allowedContent: true,
                    }"
                  ></ckeditor>
                </v-col>

                <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                  <p>Banner:</p>
                  <input
                    style="display: none"
                    type="file"
                    ref="iptBanner"
                    @change.prevent="cargarBanner"
                    accept="image/*"
                  />
                  <div class="custom-my-dropzone">
                    <v-row>
                      <v-col cols="12" class="text-center" v-show="urlBanner === ''">
                        <v-btn
                          :loading="loaderBanner"
                          color="primary"
                          @click="
                            $refs.iptBanner.value = '';
                            $refs.iptBanner.click();
                          "
                        >
                          <v-icon left>mdi-cloud-upload-outline</v-icon> CARGAR BANNER
                        </v-btn>
                      </v-col>
                      <v-col cols="12" class="text-center" v-show="urlBanner !== ''">
                        <v-btn icon color="red" small @click.prevent="eliminarBanner">
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                        <v-img :src="urlBanner" height="200" contain> </v-img>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                  <p>Imagen Compartir:</p>
                  <input
                    style="display: none"
                    type="file"
                    ref="iptImagenCompartir"
                    @change.prevent="cargarImagenCompartir"
                    accept="image/*"
                  />
                  <div class="custom-my-dropzone">
                    <v-row>
                      <v-col
                        cols="12"
                        class="text-center"
                        v-show="urlImagenCompartir === ''"
                      >
                        <v-btn
                          :loading="loaderImagenCompartir"
                          color="primary"
                          @click="
                            $refs.iptImagenCompartir.value = '';
                            $refs.iptImagenCompartir.click();
                          "
                        >
                          <v-icon left>mdi-cloud-upload-outline</v-icon> CARGAR IMAGEN
                          COMPARTIR
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="text-center"
                        v-show="urlImagenCompartir !== ''"
                      >
                        <v-btn
                          icon
                          color="red"
                          small
                          @click.prevent="eliminarImagenCompartir"
                        >
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                        <v-img :src="urlImagenCompartir" height="200" contain> </v-img>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>

                <v-col cols="12">
                  <p class="red--text"></p>
                  <v-select
                    dense
                    item-text="texto"
                    item-value="valor"
                    :items="cmbEstado"
                    label="Estado(*)"
                    outlined
                    v-model="blog.estado"
                  ></v-select>
                </v-col>

                <v-col cols="12" class="text-center">
                  <v-btn
                    class="mr-2"
                    type="submit"
                    :loading="processForm"
                    color="success"
                    large=""
                  >
                    <v-icon left="" large="">mdi-content-save</v-icon> GUARDAR
                  </v-btn>
                  <v-btn
                    :to="{ name: 'blogsPanel' }"
                    type="button"
                    :loading="processForm"
                    color="error"
                    large=""
                  >
                    <v-icon left="" large="">mdi-close</v-icon> CANCELAR
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      blog: {
        titulo: "",
        contenido: "",
        google: "",
        descripcion: "",
        banner: "",
        imagen_compartir: "",
        estado: 1,
      },
      cmbEstado: [
        {
          texto: "Habilitado",
          valor: 1,
        },
        {
          texto: "Inhabilitado",
          valor: 0,
        },
      ],
      processForm: false,
      listErrors: [],
      alertError: false,
      loaderBanner: false,
      urlBanner: "",
      loaderImagenCompartir: false,
      urlImagenCompartir: "",
    };
  },

  methods: {
    cargarBanner(event) {
      this.loaderBanner = true;

      if (this.urlBanner !== "") {
        this.$toasted.error("Ya hay un archivo cargado");
        this.loaderBanner = false;
        return;
      }

      if (event.target.files.length > 0) {
        let banner = event.target.files[0];
        this.urlBanner = URL.createObjectURL(banner);
        this.blog.banner = banner;
      }

      this.loaderBanner = false;
    },

    eliminarBanner() {
      this.urlBanner = "";
      this.blog.banner = "";
    },

    cargarImagenCompartir(event) {
      this.loaderImagenCompartir = true;

      if (this.urlImagenCompartir !== "") {
        this.$toasted.error("Ya hay un archivo cargado");
        this.loaderImagenCompartir = false;
        return;
      }

      if (event.target.files.length > 0) {
        let imagenCompartir = event.target.files[0];
        this.urlImagenCompartir = URL.createObjectURL(imagenCompartir);
        this.blog.imagen_compartir = imagenCompartir;
      }

      this.loaderImagenCompartir = false;
    },

    eliminarImagenCompartir() {
      this.urlImagenCompartir = "";
      this.blog.imagen_compartir = "";
    },

    guardar() {
      this.alertError = false;
      this.processForm = true;

      this.axios({
        method: "POST",
        url: "api/panel/blogs",
        data: this.serialize(this.blog),
      })
        .then((response) => {
          let status = response.status;
          if (status === 200) {
            this.$toasted.success(response.data.data, {
              icon: "mdi-check-bold",
            });
            this.$router.push({
              name: "blogsPanel",
            });
          } else {
            console.log(response);
          }
        })
        .catch((error) => {
          let status = error.response.status;
          if (status === 422) {
            let arrErrors = error.response.data.errors;
            this.listErrors = Object.values(arrErrors);
            this.alertError = true;
            this.$vuetify.goTo(this.$refs.mensajeError);
          } else {
            this.$toasted.error("Ocurrio un error al guardar este registro", {
              icon: "mdi-close",
            });
          }
        })
        .finally(() => {
          this.processForm = false;
        });
    },
  },

  created() {
    if (!this.validarPermiso("blogs.crear")) {
      this.$toasted.error("Usted no tiene permisos para esta sección", {
        icon: "mdi-close",
      });

      this.$router.push({
        name: "inicioPanel",
      });
    }
    window.scrollTo(0, 0);
  },
};
</script>
